// extracted by mini-css-extract-plugin
export var avatarContainer = "_bu-0";
export var avatarTypingWave = "_bu-i";
export var gray = "_bu-f";
export var green = "_bu-c";
export var icon = "_bu-9";
export var image = "_bu-1";
export var lg = "_bu-6";
export var md = "_bu-5";
export var presenceDot = "_bu-b";
export var red = "_bu-d";
export var sm = "_bu-4";
export var status = "_bu-a";
export var typingDot = "_bu-h";
export var typingPill = "_bu-g";
export var xl = "_bu-7";
export var xs = "_bu-3";
export var xxl = "_bu-8";
export var xxs = "_bu-2";
export var yellow = "_bu-e";